import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

interface Props {}

const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  padding: ${rem(16)};
  min-width: 0px;
`

const CardContainer = ({ children }: PropsWithChildren<Props>) => {
  return <Container>{children}</Container>
}

export default CardContainer
